export default __webpack_public_path__ + "b096c0d9a1666e1c23b7b8b0e72c855f.svg";